import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from '@ami/react/core';
import { CustomerApprovalView } from '@ami/react/shared';
import { formatDateWithTime } from '@ami/react/core';
import { Button } from 'reactstrap';
import { customerApprovalDocumentLookupServices } from '@ami/react/shared';

const DownloadDocumentRevisionButton = ({
  onClick,
  revisionId,
  revisionIdDownloading,
}) => {
  const isDownloading = revisionId === revisionIdDownloading;

  return (
    <Button
      title={isDownloading ? 'Downloading' : 'Download Document'}
      className="btn btn-outline-primary"
      onClick={() => onClick(revisionId)}
    >
      {isDownloading && <i className="fa fa-spin fa-spinner" />}
      {!isDownloading && <div>Download PDF</div>}
    </Button>
  );
};

class RevisionDocument extends React.Component {
  static propTypes = {
    entity: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  render() {
    const { entity, onClick } = this.props;
    return (
      <tr>
        <td>{entity.id}</td>
        <td>{formatDateWithTime(entity.dateCreated)}</td>
        <td>
          <DownloadDocumentRevisionButton
            onClick={onClick}
            revisionId={entity.id}
            revisionIdDownloading={this.state}
          />
        </td>
      </tr>
    );
  }
}

export default class RevisionDocumentListModalComponent extends React.Component {
  constructor(props) {
    super(props);
    this.downloadDocumentRevision = this.downloadDocumentRevision.bind(this);
  }

  static propTypes = {
    entity: PropTypes.instanceOf(CustomerApprovalView).isRequired,
    documentId: PropTypes.string.isRequired,
    showModal: PropTypes.bool.isRequired,
    hideModal: PropTypes.func.isRequired,
  };

  state = {
    submitting: false,
  };

  downloadDocumentRevision = (revision) => {
    this.setState({ submitting: true });
    customerApprovalDocumentLookupServices
      .getDownloadRevisionUrl(
        this.props.entity.id,
        this.props.documentId,
        revision
      )
      .then((response) => (window.location = response.url))
      .finally(() => this.setState({ submitting: false }));
  };

  hide = () => this.props.hideModal();

  render() {
    const { entity, documentId } = this.props;
    return (
      <Modal
        size="lg"
        title={`Document Revisions`}
        show={this.props.showModal}
        showCancel={true}
        onCancel={this.hide}
        submitting={this.state.submitting}
        closeOnOk={false}
        onShowUpdated={(showModal) => {
          if (!showModal) this.hide();
        }}
        cancelTitle="Close"
        showOk={false}
        onOk={() => null}
      >
        <table className="table table-mobile" style={{ marginBottom: '0px' }}>
          <thead>
            <tr>
              <th width="15%">Revision #</th>
              <th width="80%">Date</th>
              <th width="5%" />
            </tr>
          </thead>
          <tbody>
            {documentId &&
              entity &&
              entity.documents
                .find((x) => x.id === documentId)
                .approvalDocumentRevisions.slice(0)
                .reverse()
                .map((document, i) => (
                  <RevisionDocument
                    key={i}
                    entity={document}
                    onClick={this.downloadDocumentRevision}
                  />
                ))}
          </tbody>
        </table>
      </Modal>
    );
  }
}
